import { Component, OnInit } from '@angular/core';
import {Ticket} from '../../domain/tickets';
import {FormService} from '../../services/formServices';
import {ActivatedRoute, Router} from '@angular/router';
import {SessionService} from '../../../core/services/sessionService';
import { FilesService } from './../../services/files.service';

@Component({
  selector: 'app-pedido-generado',
  templateUrl: './pedido-generado.component.html',
  styleUrls: ['./pedido-generado.component.scss']
})
export class PedidoGeneradoComponent implements OnInit {
    ticketId: number;
    ticket: Ticket;
    adjuntos?: any;
    data: any;
    constructor(private filesService: FilesService,
                private formService: FormService,
                private sessionService: SessionService,
                private route: ActivatedRoute,
                private router: Router) { }

    ngOnInit() {
        this.data = this.sessionService.getSession();
        this.route.params.subscribe(
            params => {
                this.ticketId = params['id'];
            }
        );
      this.formService.getTicket(this.ticketId).subscribe(
          ticket => this.ticket = ticket
      );
      this.filesService.getFiles(this.ticketId).subscribe(
        adjuntos => {
          this.adjuntos = adjuntos;
      }
    );
  }

  print(){
    window.print();
}

    volver(){
        window.history.back();
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/comprobante/pedido-generado.component.ts